import { ROOT } from '../../constants/routeTemplates';

export const SET_BACK_URL = 'SET_BACK_URL';
export const CHANGE_URL = 'CHANGE_URL';

export const urlWasChanged = (payload) => ({ type: CHANGE_URL, payload });
export const setBackUrl = (payload) => ({ type: SET_BACK_URL, payload });

const initialState = [ROOT];

export const reducer = (state = initialState, action) => {
  switch (action?.type) {
    case CHANGE_URL:
      return state?.includes(action.payload)
        ? [
            ...state.concat().splice(0, state?.indexOf(action.payload)),
            action.payload,
          ]
        : [...state, action.payload];
    case SET_BACK_URL:
      return [action.payload, ...state];
    default:
      return [ROOT];
  }
};
